<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="机构名称">
              <j-search-select-tag
                placeholder="请选择机构"
                v-model="queryParam.id"
                dict="school_org,name,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="手机号码">
              <a-input placeholder="请输入手机号码" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="visit(record)">访问地址</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <schoolOrg-modal ref="modalForm" @ok="modalFormOk"></schoolOrg-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import SchoolOrgModal from './modules/SchoolOrgModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: "SchoolOrgList",
    mixins:[JeecgListMixin],
    components: {
      SchoolOrgModal,
      JSearchSelectTag
    },
    data () {
      return {
        description: '第三方机构管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		      {
            title: '机构名称',
            align:"center",
            dataIndex: 'name'
           },
		      {
            title: '手机号码',
            align:"center",
            dataIndex: 'phone'
           },
          {
            title: '分成比例（%）',
            align:"center",
            dataIndex: 'shareRatio'
          },
		      {
            title: '接入学校数',
            align:"center",
            dataIndex: 'schoolNum'
          },
		      {
            title: '激活数',
            align:"center",
            dataIndex: 'activeUsers'
          },
		      {
            title: '学生数',
            align:"center",
            dataIndex: 'studentNum'
          },
		      {
            title: '付费金额',
            align:"center",
            dataIndex: 'paymentAmount'
          },
		      {
            title: '累计奖金',
            align:"center",
            dataIndex: 'accumulatedAmount'
          },
		      // {
          //   title: '可发放金额',
          //   align:"center",
          //   dataIndex: 'distributableAmount'
          // },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		    url: {
          list: "/schoolOrg/list",
          delete: "/schoolOrg/delete",
          deleteBatch: "/schoolOrg/deleteBatch",
          exportXlsUrl: "/schoolOrg/exportXls",
          importExcelUrl: "/schoolOrg/importExcel",
        },
    }
  },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      visit (record) {
        window.open(window._CONFIG['resourceURL'] + '/org/index.html?id='+record.id)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>